module.exports = __webpack_public_path__ + "static/media/TrashWhiteRedBg.2f006fbf.svg";